import React from 'react';
import { Stack, Typography } from '@mui/material';
import TuningAdminTable, { TuningField, boolChip, safePreview } from './TuningAdminTable';

const entityTypeOptions = [
  'product',
  'product_feature',
  'product_component',
  'product_use_case',
  'solution_component',
  'go_to_market',
  'security_use_case',
  'security_use_case_component',
].map((v) => ({ label: v, value: v }));

const fields: TuningField[] = [
  { name: 'entity_type', label: 'Entity Type', type: 'select', required: true, options: entityTypeOptions },
  { name: 'title', label: 'Title', required: true },
  {
    name: 'scope_template',
    label: 'Scope Template',
    type: 'textarea',
    required: true,
    minRows: 10,
    helperText: 'Supports placeholders such as {context}, {entity_type}, {entity_name}, {context_name}.',
  },
  {
    name: 'strict_boundaries',
    label: 'Strict Boundaries',
    type: 'textarea',
    minRows: 8,
  },
  { name: 'context_heading', label: 'Context Heading' },
  { name: 'notes', label: 'Notes', type: 'textarea', minRows: 3 },
  { name: 'is_active', label: 'Active', type: 'boolean' },
];

const EntityScopesPanel: React.FC = () => {
  return (
    <TuningAdminTable
      title="Entity Scope Specs"
      description="Controls hierarchy-specific scoping, strict boundaries, and context headings."
      endpoint="db/ai-entity-scope-spec/"
      queryKey={['ai-entity-scope-spec']}
      fields={fields}
      defaultValues={{
        entity_type: 'product_feature',
        title: '',
        scope_template: '',
        strict_boundaries: '',
        context_heading: '',
        notes: '',
        is_active: true,
      }}
      orderBy="entity_type"
      rowTitle={(row) => row.title || row.entity_type}
      rowSubtitle={(row) => safePreview(row.scope_template, 180)}
      columns={[
        {
          key: 'entity_type',
          label: 'Entity Type',
          width: 230,
          render: (row) => (
            <Stack spacing={0.25}>
              <Typography variant="body2" fontWeight={700}>
                {row.entity_type}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {row.title}
              </Typography>
            </Stack>
          ),
        },
        {
          key: 'scope_template',
          label: 'Scope',
          render: (row) => (
            <Typography variant="caption" sx={{ whiteSpace: 'pre-wrap' }}>
              {safePreview(row.scope_template, 260)}
            </Typography>
          ),
        },
        {
          key: 'context_heading',
          label: 'Context Heading',
          width: 220,
          render: (row) => row.context_heading || '-',
        },
        {
          key: 'is_active',
          label: 'Active',
          width: 100,
          render: (row) => boolChip(row.is_active),
        },
      ]}
    />
  );
};

export default EntityScopesPanel;